import React from 'react';
import ReactPaginate from 'react-paginate';
import './style.css';

const Paging = ({ totalPages, onChange }) => {
  return (
    <div className="alert-pagination">
      <nav className='ml-auto'>
        <ReactPaginate
          pageCount={totalPages}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={({ selected }) => onChange(selected + 1)}
          containerClassName="pagination pagination-sm justify-content-end"
          activeClassName="active"
          pageLinkClassName="page-link"
          breakLinkClassName="page-link"
          nextLinkClassName="page-link"
          previousLinkClassName="page-link"
          pageClassName="page-item"
          breakClassName="page-item"
          nextClassName="page-item"
          previousClassName="page-item"
          previousLabel={'Previous'}
          nextLabel={'Next'}
        />
      </nav>
    </div>
  )
}

export default Paging;


/** WEBPACK FOOTER **
 ** ./src/components/Paging/index.js
 **/